import * as React           from "react";
import {ModalState, ShowModalAsync} from '../types';

export const CustomModalContext = React.createContext<ShowModalAsync>(_ => new Promise<ModalState>(resolve => { resolve(ModalState.Closed)}));
